import { type FlowBucket } from '@taler/api-client'
import { type LocalDate, plusMonths, startOfMonth, startOfYear } from '@taler/domain'

export const FLOW_PERIODS = ['month', 'quarter', 'year', 'all'] as const
export type FlowPeriod = (typeof FLOW_PERIODS)[number]

export interface PeriodRange {
  /** Undefined for all time: the backend starts at the account's first entry. */
  readonly from: LocalDate | undefined
  readonly until: LocalDate
  readonly bucket: FlowBucket
}

export function parseFlowPeriod(raw: unknown): FlowPeriod {
  return FLOW_PERIODS.find((candidate) => candidate === raw) ?? 'month'
}

/** Month buckets for the windowed presets; all time is one bucket per year. */
export function periodRange(period: FlowPeriod, today: LocalDate): PeriodRange {
  switch (period) {
    case 'month':
      return { from: startOfMonth(today), until: today, bucket: 'MONTH' }
    case 'quarter':
      return { from: startOfMonth(plusMonths(today, -2)), until: today, bucket: 'MONTH' }
    case 'year':
      return { from: startOfYear(today), until: today, bucket: 'MONTH' }
    case 'all':
      return { from: undefined, until: today, bucket: 'YEAR' }
  }
}
